module.exports = __webpack_public_path__ + "assets/media/client-1.eec3f47c.svg";